<template>
  <div class="problem" >
    <Cell title="General Questions" center is-link url="/#/problem/general" ></Cell>
    <Cell title="Installation" center is-link url="/#/problem/installation"></Cell>
    <Cell title="Troublesshooting" center is-link url="/#/problem/troubleshooting"></Cell>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        
      }
    }
  }
</script>

<style lang="less" scoped>
  .problem{
    .van-cell {
      padding: 0 15px 0 30px;
      height: 50px;
      color: #363C54;
      font: bold 14px 'PingFang SC'
    }
    .van-cell::after {
      border-bottom: none;
    }
  }
</style>